import { FileClassificationStatus } from "@inrev/common";

/**
 * Surfaces should resolve to one of these and render via `FileUploadStatusIndicator`.
 */
export const FileUploadStatus = {
	uploading: "uploading",
	classifying: "classifying",
	awaitingReview: "awaiting_review",
	classificationFailed: "classification_failed",
	uploadFailed: "upload_failed",
	ready: "ready",
} as const;

export type FileUploadStatus = (typeof FileUploadStatus)[keyof typeof FileUploadStatus];

export type ResolveFileUploadStatusInput = {
	/** Local client upload in flight (before server file exists / settles). */
	uploading?: boolean;
	/** Local client upload failed. */
	uploadFailed?: boolean;
	classificationStatus?: FileClassificationStatus;
	hasTypes?: boolean;
	typesConfirmedByAdmin?: boolean;
};

export const resolveFileUploadStatus = ({
	uploading = false,
	uploadFailed = false,
	classificationStatus,
	hasTypes = false,
	typesConfirmedByAdmin = false,
}: ResolveFileUploadStatusInput): FileUploadStatus => {
	if (uploadFailed) return FileUploadStatus.uploadFailed;
	if (uploading) return FileUploadStatus.uploading;

	switch (classificationStatus) {
		case FileClassificationStatus.pending:
			return hasTypes ? FileUploadStatus.ready : FileUploadStatus.classifying;
		case FileClassificationStatus.failed:
			return hasTypes ? FileUploadStatus.ready : FileUploadStatus.classificationFailed;
		case FileClassificationStatus.completed:
			return typesConfirmedByAdmin ? FileUploadStatus.ready : FileUploadStatus.awaitingReview;
		case FileClassificationStatus.not_started:
		default:
			return FileUploadStatus.ready;
	}
};
